import { render, staticRenderFns } from "./IndexBBox.vue?vue&type=template&id=11231df1"
import script from "./IndexBBox.vue?vue&type=script&lang=js"
export * from "./IndexBBox.vue?vue&type=script&lang=js"
import style0 from "./IndexBBox.vue?vue&type=style&index=0&id=11231df1&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports